// extracted by mini-css-extract-plugin
module.exports = {"descriptions":"styles_descriptions__2k-ij"};